<div class="modal-header">
    <h5 class="modal-title">Do you wish to restore this Customer?</h5>
    <button type="button" class="close" data-dismiss="modal" (click)="closeModal('dismiss')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    

<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
               
                <div class="card-body custom-datatable noscroll">
                    <div class="custom-datatable1">
                        <form [formGroup]="revetCustomerForm" class="needs-validation" (ngSubmit)="revertCustomerId()">
                            <div class="row">
                                <div class="col-sm-12 col-xl-12">
                                   
                                        <div class="col-md-12 mb-3">
                                            <label for="nameOfDP">Reason to Restore Customer</label>
                                            <textarea class="form-control" rows="5" id="reasonforrestore" placeholder="Reason to Restore Customer" formControlName="reasonforrestore" autocomplete="off" 
                                            [ngClass]="{ 'is-invalid': (submitted || revetCustomerForm.controls.reasonforrestore.touched) && revetCustomerForm.controls.reasonforrestore.errors }"></textarea>
                                            <div *ngIf="(submitted || revetCustomerForm.controls.reasonforrestore.touched) && revetCustomerForm.controls.reasonforrestore.errors?.required"
                                            class="text text-danger">
                                            Please mention the reason to Restore Customer
                                            </div>   
                                            <div class="text text-danger" *ngIf="revetCustomerForm.controls.reasonforrestore.errors?.pattern">Special Charactors Not Allowed!</div>
                                  
                                        </div>
                                        <div class="submit-btn">
                                            <button class="btn btn-primary" [disabled]="isLoading" type="submit"><i class="fa" [ngClass]="{'fa-spin fa-spinner': isLoading, 'fa-check': !isLoading}"></i> {{button}}</button>   
                                            <button class="btn btn-warning" type="button" (click)="closeModal('close')">Cancel</button>   
                                            <!-- <button class="btn btn-primary me-1" (click)="revertProjectId()">Yes</button>
                                            <button class="btn btn-primary me-1" (click)="closeModal('close')">No</button>                  -->
                                         </div>
                                </div>
                            </div>
                        </form> 
                    </div>
                </div>
                <div class="card-footer text-muted">
                    <!-- <b>Note:</b> Restoring of {{title}} will extract profile information only. Access to the {{title}} must be granted afresh based on current requirements. -->
                    <b>Note:</b> Restoring this {{title}} will extract profile information only. Please grant the {{title}} SDD access again.<br><span>This is to comply with current legal requirements.</span>
                </div>
            </div>
        </div>
    </div>
 </div>
</div>
<!-- <div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModal('close')">Close</button>
</div> -->
